import { hasCapability, type User } from "../base";

export const measurementReport = {
  read: (user: User) => hasCapability(user, "measurementReport.read"),
};
